import { render, staticRenderFns } from "./Disposisi.vue?vue&type=template&id=794876f0&"
import script from "./Disposisi.vue?vue&type=script&lang=js&"
export * from "./Disposisi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports